export default {
  setUser(state, payload) {
    state.token = payload.token;
  },
  setBalance(state, payload) {
    state.balance = payload.balance;
  },
};
